import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

interface RedistributeResult {
  redistributed_count: number;
  consultants_count: number;
}

export const useDeactivateUserWithRedistribution = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (userId: string): Promise<RedistributeResult> => {
      const { data, error } = await supabase.rpc('redistribute_deals_and_deactivate', {
        p_user_id: userId,
      });
      if (error) throw error;
      return data as unknown as RedistributeResult;
    },
    onSuccess: (result) => {
      toast.success(
        `Usuário inativado. ${result.redistributed_count} ${
          result.redistributed_count === 1 ? 'deal redistribuído' : 'deals redistribuídos'
        } entre ${result.consultants_count} ${
          result.consultants_count === 1 ? 'consultor' : 'consultores'
        }.`
      );
      queryClient.invalidateQueries({ queryKey: ['app-users'] });
      queryClient.invalidateQueries({ queryKey: ['deals'] });
      queryClient.invalidateQueries({ queryKey: ['contacts'] });
    },
    onError: (error: Error) => {
      const msg = error.message?.includes('no_active_consultants')
        ? 'Não há Consultores de Vendas ativos disponíveis para receber os deals.'
        : error.message?.includes('forbidden')
        ? 'Apenas administradores podem inativar usuários com deals ativos.'
        : `Erro ao inativar usuário: ${error.message}`;
      toast.error(msg);
    },
  });
};
